import { SUPPORTED_LANGUAGES_TYPE } from "../../../i18n";
import CSFlag from "./cs.svg";
import SKFlag from "./sk.svg";
import UKFlag from "./uk.svg";

export const getLngIcon = (lng: SUPPORTED_LANGUAGES_TYPE) => {
  switch (lng.toLowerCase()) {
    case "cs":
      return <CSFlag />;
    case "en":
      return <UKFlag />;
    case "sk":
      return <SKFlag />;
  }
};
